import React, { useContext } from 'react';
import { CButton } from '@app/components/Common/';
import { TradeRealTimeFilterSection } from './OrderBook/styles';
import { View } from '@/styles/reactnative';
import { COLORS } from '@app/constants/';
import { ThemeContext } from '@/theme/ThemeProvider';
import DefaultIcon from '../assets/default.svg?react';
import AskIcon from '../assets/ask.svg?react';
import BidIcon from '../assets/bid.svg?react';
import styled from 'styled-components';

const TradeRealTimeFilter = ({
  filterTab,
  setFilterTab,
  grouplist,
  selected,
  setSelected,
}: any) => {
  const { isDarkMode, theme } = useContext(ThemeContext);
  // const lightDefault = IMAGES.lightDefault
  // const lightAsk = IMAGES.lightAsk
  // const lightBid = IMAGES.lightBid
  // const darkDefault = IMAGES.darkDefault
  // const darkAsk = IMAGES.darkAsk
  // const darkBid = IMAGES.darkBid
  const data = [
    { name: 'one', Icon: BothSvg },
    { name: 'two', Icon: BidSvg },
    { name: 'three', Icon: AskSvg },
  ];

  return (
    <TradeRealTimeFilterSection>
      <View style={{ flexDirection: 'row', gap: 5 }}>
        {data.map((item, index) => {
          const Icon = item.Icon;
          return (
            <IconButton
              key={index.toString()}
              onClick={() => setFilterTab(item.name)}
              $isActive={item.name === filterTab}
            >
              <Icon />
            </IconButton>
          );
        })}
      </View>
      {/*
			<NormalDropdown
				title={selected}
				setSelected={setSelected}
				selected={selected}
				data={grouplist}
				style={{
					marginLeft: -50,
				}}
				btnStyle={{
					backgroundColor: COLORS.gray,
					paddingBlock: 2,
					marginTop: 5,
				}}
			/> */}
    </TradeRealTimeFilterSection>
  );
};

export default React.memo(TradeRealTimeFilter);

const IconButton = styled.button<{ $isActive: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  opacity: ${({ $isActive }) => ($isActive ? 1 : 0.8)};

  &:hover {
    opacity: 1;
  }
`;

const BothSvg = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M2.09961 3.7998C2.09961 3.24752 2.54732 2.7998 3.09961 2.7998H4.09982C4.65211 2.7998 5.09982 3.24752 5.09982 3.7998V6.59981C5.09982 7.15209 4.65211 7.5998 4.09982 7.5998H3.09961C2.54732 7.5998 2.09961 7.15209 2.09961 6.5998V3.7998Z"
        fill="#F44336"
      />
      <path
        d="M2.09961 9.3999C2.09961 8.84762 2.54732 8.3999 3.09961 8.3999H4.09982C4.65211 8.3999 5.09982 8.84762 5.09982 9.3999V12.1999C5.09982 12.7522 4.65211 13.1999 4.09982 13.1999H3.09961C2.54732 13.1999 2.09961 12.7522 2.09961 12.1999V9.3999Z"
        fill="#07D962"
      />
      <path
        d="M5.89941 3.7998C5.89941 3.24752 6.34713 2.7998 6.89941 2.7998H12.8994C13.4517 2.7998 13.8994 3.24752 13.8994 3.7998C13.8994 4.35209 13.4517 4.7998 12.8994 4.7998H6.89941C6.34713 4.7998 5.89941 4.35209 5.89941 3.7998Z"
        fill="#E9E9ED"
      />
      <path
        d="M5.89941 6.59961C5.89941 6.04732 6.34713 5.59961 6.89941 5.59961H12.8994C13.4517 5.59961 13.8994 6.04732 13.8994 6.59961C13.8994 7.15189 13.4517 7.59961 12.8994 7.59961H6.89941C6.34713 7.59961 5.89941 7.15189 5.89941 6.59961Z"
        fill="#E9E9ED"
      />
      <path
        d="M5.89941 9.3999C5.89941 8.84762 6.34713 8.3999 6.89941 8.3999H12.8994C13.4517 8.3999 13.8994 8.84762 13.8994 9.3999C13.8994 9.95219 13.4517 10.3999 12.8994 10.3999H6.89941C6.34713 10.3999 5.89941 9.95219 5.89941 9.3999Z"
        fill="#E9E9ED"
      />
      <path
        d="M5.89941 12.1997C5.89941 11.6474 6.34713 11.1997 6.89941 11.1997H12.8994C13.4517 11.1997 13.8994 11.6474 13.8994 12.1997C13.8994 12.752 13.4517 13.1997 12.8994 13.1997H6.89941C6.34713 13.1997 5.89941 12.752 5.89941 12.1997Z"
        fill="#E9E9ED"
      />
    </svg>
  );
};

const BidSvg = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M2.09961 3.79981C2.09961 3.24752 2.54732 2.7998 3.09961 2.7998H4.09982C4.65211 2.7998 5.09982 3.24752 5.09982 3.7998V12.1998C5.09982 12.7521 4.65211 13.1998 4.09982 13.1998H3.09961C2.54732 13.1998 2.09961 12.7521 2.09961 12.1998V3.79981Z"
        fill="#07D962"
      />
      <path
        d="M5.89941 3.7998C5.89941 3.24752 6.34713 2.7998 6.89941 2.7998H12.8994C13.4517 2.7998 13.8994 3.24752 13.8994 3.7998C13.8994 4.35209 13.4517 4.7998 12.8994 4.7998H6.89941C6.34713 4.7998 5.89941 4.35209 5.89941 3.7998Z"
        fill="#E9E9ED"
      />
      <path
        d="M5.89941 6.59961C5.89941 6.04732 6.34713 5.59961 6.89941 5.59961H12.8994C13.4517 5.59961 13.8994 6.04732 13.8994 6.59961C13.8994 7.15189 13.4517 7.59961 12.8994 7.59961H6.89941C6.34713 7.59961 5.89941 7.15189 5.89941 6.59961Z"
        fill="#E9E9ED"
      />
      <path
        d="M5.89941 9.3999C5.89941 8.84762 6.34713 8.3999 6.89941 8.3999H12.8994C13.4517 8.3999 13.8994 8.84762 13.8994 9.3999C13.8994 9.95219 13.4517 10.3999 12.8994 10.3999H6.89941C6.34713 10.3999 5.89941 9.95219 5.89941 9.3999Z"
        fill="#E9E9ED"
      />
      <path
        d="M5.89941 12.1997C5.89941 11.6474 6.34713 11.1997 6.89941 11.1997H12.8994C13.4517 11.1997 13.8994 11.6474 13.8994 12.1997C13.8994 12.752 13.4517 13.1997 12.8994 13.1997H6.89941C6.34713 13.1997 5.89941 12.752 5.89941 12.1997Z"
        fill="#E9E9ED"
      />
    </svg>
  );
};

const AskSvg = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M2.09961 3.79981C2.09961 3.24752 2.54732 2.7998 3.09961 2.7998H4.09982C4.65211 2.7998 5.09982 3.24752 5.09982 3.7998V12.1998C5.09982 12.7521 4.65211 13.1998 4.09982 13.1998H3.09961C2.54732 13.1998 2.09961 12.7521 2.09961 12.1998V3.79981Z"
        fill="#F44336"
      />
      <path
        d="M5.89941 3.7998C5.89941 3.24752 6.34713 2.7998 6.89941 2.7998H12.8994C13.4517 2.7998 13.8994 3.24752 13.8994 3.7998C13.8994 4.35209 13.4517 4.7998 12.8994 4.7998H6.89941C6.34713 4.7998 5.89941 4.35209 5.89941 3.7998Z"
        fill="#E9E9ED"
      />
      <path
        d="M5.89941 6.59961C5.89941 6.04732 6.34713 5.59961 6.89941 5.59961H12.8994C13.4517 5.59961 13.8994 6.04732 13.8994 6.59961C13.8994 7.15189 13.4517 7.59961 12.8994 7.59961H6.89941C6.34713 7.59961 5.89941 7.15189 5.89941 6.59961Z"
        fill="#E9E9ED"
      />
      <path
        d="M5.89941 9.3999C5.89941 8.84762 6.34713 8.3999 6.89941 8.3999H12.8994C13.4517 8.3999 13.8994 8.84762 13.8994 9.3999C13.8994 9.95219 13.4517 10.3999 12.8994 10.3999H6.89941C6.34713 10.3999 5.89941 9.95219 5.89941 9.3999Z"
        fill="#E9E9ED"
      />
      <path
        d="M5.89941 12.1997C5.89941 11.6474 6.34713 11.1997 6.89941 11.1997H12.8994C13.4517 11.1997 13.8994 11.6474 13.8994 12.1997C13.8994 12.752 13.4517 13.1997 12.8994 13.1997H6.89941C6.34713 13.1997 5.89941 12.752 5.89941 12.1997Z"
        fill="#E9E9ED"
      />
    </svg>
  );
};
